import React, { Suspense, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { MsalProvider } from '@azure/msal-react';
import PropTypes from 'prop-types';
import AppRoutes from './routes/Routes';
import './styles/App.scss';
import { theme } from './Theme';

import { startSASTokenRefresh } from './service/API';

import '@abi-labs-hexa/web-v2/core/theme/index.css';
import { initDataDog } from './monitoring/monitoring';

initDataDog();

const getBasePath = () => {
  const buildTimeBasePath = process.env.REACT_APP_PUBLIC_BASE_PATH;
  if (buildTimeBasePath && buildTimeBasePath !== '/') {
    return buildTimeBasePath;
  }
  const pathname = window.location.pathname;
  const prRegex = /^(\/PR\d+)/;
  const prMatch = prRegex.exec(pathname);
  if (prMatch) {
    return prMatch[1];
  }
  return '/';
};

const BASENAME = getBasePath();

function App({ instance }) {
  const isAuthenticated = localStorage.getItem('isLoggedin');

  useEffect(() => {
    instance
      .initialize()
      .then(() => {
        const fetchSasKey = async () => {
          if (isAuthenticated) {
            await startSASTokenRefresh();
          }
        };
        fetchSasKey();
      })
      .catch((error) => {
        console.error('Initialization error:', error);
      });
  }, [isAuthenticated, instance]);

  return (
    <Suspense>
      <BrowserRouter basename={BASENAME}>
        <ThemeProvider theme={theme}>
          <MsalProvider instance={instance}>
            <AppRoutes />
          </MsalProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Suspense>
  );
}

App.propTypes = {
  instance: PropTypes.object.isRequired
};

export default App;
